// Show types - matches the `shows.show_type` column (see migration
// 20260618000000_roadshow_studio_kit_show_types.sql).
//
// The same show settings page serves both on-site and road shows. The show
// detail page warns that some features may not work for road shows.
export const SHOW_TYPES = {
  ON_SITE: "on_site",
  ON_ROAD: "on_road",
} as const;

export type ShowType = (typeof SHOW_TYPES)[keyof typeof SHOW_TYPES];

export const SHOW_TYPE_LABELS: Record<ShowType, string> = {
  [SHOW_TYPES.ON_SITE]: "On-site show",
  [SHOW_TYPES.ON_ROAD]: "Road show",
};

export const isRoadShow = (showType?: string | null): boolean =>
  showType === SHOW_TYPES.ON_ROAD;
